(function(){try{if(typeof document<`u`){var e=document.createElement(`style`);e.appendChild(document.createTextNode(`._errorWrapper_171rr_1{word-break:break-word}._copyIcon_171rr_5{cursor:pointer;color:var(--dixa-typography-color-secondary)}._wrapper_1lmim_1{margin-bottom:var(--dixa-size-spacer-300)}._wrapperBox_1lmim_4{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._wrapperBoxErrorBorder_1lmim_9{border-color:var(--dixa-typography-color-error)}/*$vite$:1*/`)),document.head.appendChild(e)}}catch(e){console.error(`vite-plugin-css-injected-by-js`,e)}})();
import { gql as e, isApolloError as t, useLazyQuery as n, useMutation as r, useQuery as i } from "@apollo/client";
import { getOperationName as a } from "@apollo/client/utilities";
import { Badge as o, Banner as s, Button as c, FieldText as l, FieldWrapper as u, FlexBox as d, FormField as f, Icon as p, List as m, Modal as h, ModalBody as g, ModalFoot as _, ModalHead as v, Spinner as y, Tag as b, Text as x, Tooltip as S } from "@dixa/lib-shared-habla";
import { colors as C } from "@dixa/lib-shared-tokens";
import { createContext as w, createElement as T, useCallback as E, useContext as D, useEffect as O, useMemo as k, useState as A } from "react";
import { Fragment as j, jsx as M, jsxs as N } from "react/jsx-runtime";
import { FormProvider as ee, useController as P } from "react-hook-form";
import te from "moment";
import { useInterval as ne, useMount as re, useUnmount as ie } from "react-use";
import F from "lodash/lowerCase";
import I from "lodash/upperFirst";
import { MockedProvider as ae } from "@apollo/client/testing";
import { render as L } from "@testing-library/react";
import { HookFormText as R } from "lib-shared-hook-form";
import oe from "classnames";
//#region src/apis/widgetConfiguration/queries/widgetConfiguration.query.ts
var z = e`
  query getWidgetConfiguration($id: ID!) {
    Management {
      widgetConfigurations(id: $id) {
        id
        type
        enabled
        name
        misconfigured
        misconfigurationCause
        additionalProperties
        settings {
          key
          value
        }
      }
    }
  }
`, B = e`
  mutation updateWidgetConfiguration(
    $id: ID!
    $enabled: Boolean
    $name: String!
    $settings: [Management_SettingInput!]
  ) {
    Management {
      updateWidgetConfiguration(
        id: $id
        enabled: $enabled
        name: $name
        settings: $settings
      ) {
        id
        name
        enabled
        misconfigured
        misconfigurationCause
        additionalProperties
        settings {
          key
          value
        }
      }
    }
  }
`, V = e`
  mutation createWidgetConfiguration(
    $type: String!
    $enabled: Boolean!
    $name: String!
    $settings: [Management_SettingInput!]!
  ) {
    Management {
      createWidgetConfiguration(
        type: $type
        enabled: $enabled
        name: $name
        settings: $settings
      ) {
        id
        name
        enabled
        misconfigured
        misconfigurationCause
        additionalProperties
        settings {
          key
          value
        }
      }
    }
  }
`, H = e`
  mutation deleteWidgetConfiguration($id: ID!) {
    Management {
      deleteWidgetConfiguration(id: $id) {
        id
      }
    }
  }
`, se = (e, t) => function(n, r) {
	return i(n, {
		...r,
		context: {
			operationName: a(n),
			...r?.context,
			widgetId: e,
			widgetType: t
		}
	});
}, U = (e, t) => function(r, i) {
	return n(r, {
		...i,
		context: {
			operationName: a(r),
			...i?.context,
			widgetId: e,
			widgetType: t
		}
	});
}, ce = (e, t, n) => function(r, i) {
	return n.query({
		query: r,
		variables: i,
		context: {
			operationName: a(r),
			widgetId: e,
			widgetType: t
		}
	});
}, le = (e, t) => function(n, i) {
	return r(n, {
		...i,
		context: {
			operationName: a(n),
			...i?.context,
			widgetId: e,
			widgetType: t
		}
	});
}, W = ({ error: e }) => e.extensions?.integration?.code === "DIXA_HEADER_CHECK_ERROR", ue = ({ errors: e }) => e.some((e) => W({ error: e })), G = ({ error: e }) => e.extensions?.integration?.code === "DOWNSTREAM_API_AUTHORIZATION_ERROR", de = ({ errors: e }) => e.some((e) => G({ error: e })), K = ({ error: e }) => e.extensions?.integration?.code === "DOWNSTREAM_API_PERMISSION_ERROR", fe = ({ errors: e }) => e.some((e) => K({ error: e })), pe = ({ error: e }) => e.extensions?.integration?.code === "DOWNSTREAM_API_SERVICE_UNAVAILABLE_ERROR", me = ({ errors: e }) => e.some((e) => pe({ error: e })), he = ({ error: e }) => e.extensions?.integration?.code === "DOWNSTREAM_API_NOT_FOUND_ERROR", ge = ({ errors: e }) => e.some((e) => he({ error: e })), _e = ({ error: e }) => e.extensions?.integration?.code === "DOWNSTREAM_API_CONFLICT_ERROR", ve = ({ errors: e }) => e.some((e) => _e({ error: e })), ye = ({ error: e }) => e.extensions?.integration?.code === "DOWNSTREAM_API_BAD_REQUEST_ERROR", be = ({ errors: e }) => e.some((e) => ye({ error: e })), q = ({ error: e }) => e.extensions?.integration?.code === "DOWNSTREAM_API_FORBIDDEN_ERROR", xe = ({ errors: e }) => e.some((e) => q({ error: e })), Se = ({ error: e }) => e.extensions?.integration?.code === "DOWNSTREAM_API_TOO_MANY_REQUESTS_ERROR", Ce = ({ errors: e }) => e.some((e) => Se({ error: e })), we = ({ error: e }) => e.extensions?.integration?.code === "WIDGET_MISCONFIGURED_ERROR", Te = ({ errors: e }) => e.some((e) => we({ error: e })), Ee = (e) => {
	let { delay: t = 2e3 } = e || {}, [n, r] = A(!1);
	return O(() => {
		let e = n ? window.setTimeout(() => r(!1), t) : void 0;
		return () => window.clearTimeout(e);
	}, [t, n]), {
		isCopied: n,
		copy: (e) => {
			navigator.clipboard.writeText(e), r(!0);
		}
	};
}, J = {
	errorWrapper: "_errorWrapper_171rr_1",
	copyIcon: "_copyIcon_171rr_5"
}, De = ({ error: e, retry: n, isMisconfigured: r = !1, hideCopyButton: i = !1 }) => {
	let a = e && t(e) && e?.graphQLErrors?.length > 0, { isCopied: o, copy: l } = Ee(), u = /* @__PURE__ */ M(p, {
		color: C.red[500],
		size: 16,
		name: "exclamation-triangle-filled"
	});
	if (r || a && Te({ errors: e.graphQLErrors })) return /* @__PURE__ */ N(d, {
		margin: "0 0 100",
		padding: "200",
		className: J.errorWrapper,
		children: [/* @__PURE__ */ M(d, {
			margin: "0 300 0 0",
			alignItems: "center",
			children: u
		}), /* @__PURE__ */ M(x.Paragraph, {
			color: "secondary",
			children: "This integration is not properly configured and could not be loaded. Please contact your administrator."
		})]
	});
	if (!a) return /* @__PURE__ */ M(d, {
		margin: "200 0",
		flexDirection: "column",
		children: /* @__PURE__ */ M(m.Item, {
			contentLeft: u,
			title: "Something went wrong. Please try again later.",
			variant: "dense"
		})
	});
	let f = e?.graphQLErrors || [];
	return /* @__PURE__ */ N(d, {
		margin: "200 0 300",
		flexDirection: "column",
		className: J.errorWrapper,
		children: [f.map((t, n) => {
			let r = t?.extensions?.integration, i = r?.message || e?.message || "No error message available", a = r?.responseBody && JSON.parse(r?.responseBody), o = a?.errorMessages || [], s = a?.warningMessages || [], c = [...o, ...s].join(" ");
			return /* @__PURE__ */ M(m.Item, {
				title: i,
				titleSecondary: c,
				contentLeft: u
			}, n);
		}), !i && /* @__PURE__ */ N(d, {
			margin: "200 0 300",
			flexDirection: "column",
			gap: "200",
			children: [/* @__PURE__ */ M(s, {
				variant: "info",
				description: /* @__PURE__ */ M(x.Paragraph, {
					variant: "4",
					children: "Please copy the error details by clicking on the button below and include them in your support request."
				})
			}), /* @__PURE__ */ N(d, {
				flexDirection: "row",
				gap: "200",
				justifyContent: "space-between",
				children: [n && /* @__PURE__ */ M(c, {
					variant: "secondary",
					icon: "sync",
					onClick: () => n(),
					children: "Retry"
				}), /* @__PURE__ */ M(c, {
					variant: "secondary",
					icon: o ? "done" : "copy",
					onClick: () => l(JSON.stringify(f, null, 2)),
					className: J.copyIcon,
					children: "Copy error payload"
				})]
			})]
		})]
	});
}, Oe = ({ headline: e, text: t, children: n, onConfirm: r, onCancel: i, confirmLabel: a, cancelLabel: o = "Cancel", confirmVariant: s = "primary", cancelVariant: c = "secondary", isOpen: l, setIsOpen: u, showOnClose: d = !1 }) => /* @__PURE__ */ N(h, {
	isOpen: l,
	onClose: () => {
		i && i(), u(!1);
	},
	children: [
		/* @__PURE__ */ M(v, {
			title: e,
			onClose: d ? i : void 0
		}),
		/* @__PURE__ */ N(g, { children: [t && /* @__PURE__ */ M("div", {
			style: { width: "600px" },
			children: t
		}), n] }),
		/* @__PURE__ */ M(_, {
			confirmOnClick: r ? () => {
				r(), u(!1);
			} : void 0,
			cancelOnClick: () => {
				i && i(), u(!1);
			},
			confirmName: a,
			cancelName: o,
			confirmProps: { variant: s },
			cancelProps: { variant: c }
		})
	]
}), ke = "The configuration of the integration is not correct. Please check the settings.", Ae = ({ cause: e }) => /* @__PURE__ */ M(d, {
	margin: "0 0 400",
	children: /* @__PURE__ */ M(s, {
		variant: "fail",
		headline: "This integration is misconfigured",
		description: /* @__PURE__ */ N(d, {
			gap: "300",
			flexDirection: "column",
			children: [/* @__PURE__ */ M(x.Paragraph, { children: e || "The configuration of the integration is not correct. Please check the settings." }), /* @__PURE__ */ N(d, {
				flexDirection: "column",
				gap: "100",
				children: [/* @__PURE__ */ M(x.Heading, {
					variant: "heading-3",
					children: "Additional information"
				}), /* @__PURE__ */ M(x.Paragraph, { children: "While the integration is in a misconfigured state, its content is not shown in the sidebar. Instead, we show a message that hints the agent to get in touch with the administrator." })]
			})]
		})
	})
}), je = ({ form: e, integrationId: t, onValidSubmit: n, error: r, onRetry: i, isLoading: a, isWidgetUnknown: o, children: s }) => r ? /* @__PURE__ */ M(De, {
	error: r,
	retry: i
}) : a ? /* @__PURE__ */ M(y, { "data-testid": "widget-settings-loading" }) : o ? /* @__PURE__ */ N(x.Paragraph, { children: [
	"A widget with the id ",
	/* @__PURE__ */ M(b, { children: t }),
	" does not exist."
] }) : /* @__PURE__ */ M(ee, {
	...e,
	children: /* @__PURE__ */ M("form", {
		noValidate: !0,
		tabIndex: -1,
		"data-testid": `widget-settings-form-${t ?? "create-new"}`,
		onSubmit: e.handleSubmit(n),
		children: s
	})
}), Me = te, Ne = F, Pe = I;
//#endregion
//#region src/utils/common.ts
function Fe(e, t = !0) {
	try {
		return JSON.parse(JSON.stringify(e));
	} catch {
		return t && console.error(`Could not make a copy of ${JSON.stringify(e)}`), {};
	}
}
var Ie = (e) => `${e.charAt(0).toUpperCase()}${e.slice(1).toLowerCase()}`, Le = (e) => {
	let t = Ne(e);
	return t.length === 0 ? e : Pe(t);
}, Re = "DD MMM YYYY @ HH:mm";
function ze(e, t) {
	return e == null ? t : typeof e == "boolean" ? e : e === "true";
}
function Be(e, t) {
	return e == null ? t : String(e);
}
//#endregion
//#region src/utils/countryCodes.ts
function Ve(e) {
	try {
		return new Intl.DisplayNames(["en"], { type: "region" }).of(e.toUpperCase()) ?? e;
	} catch {
		return e;
	}
}
var He = /* @__PURE__ */ "AF.AX.AL.DZ.AD.AO.AI.AG.AR.AM.AW.AC.AU.AT.AZ.BS.BH.BD.BB.BY.BE.BZ.BJ.BM.BT.BO.BA.BW.BV.BR.IO.BN.BG.BF.BI.KH.CA.CV.BQ.KY.CF.TD.CL.CN.CX.CC.CO.KM.CG.CD.CK.CR.HR.CU.CW.CY.CZ.CI.DK.DJ.DM.DO.EC.EG.SV.GQ.ER.EE.SZ.ET.FK.FO.FJ.FI.FR.GF.PF.TF.GA.GM.GE.DE.GH.GI.GR.GL.GD.GP.GT.GG.GN.GW.GY.HT.HM.VA.HN.HK.HU.IS.IN.ID.IR.IQ.IE.IM.IL.IT.JM.JP.JE.JO.KZ.KE.KI.KP.XK.KW.KG.LA.LV.LB.LS.LR.LY.LI.LT.LU.MO.MG.MW.MY.MV.ML.MT.MQ.MR.MU.YT.MX.MD.MC.MN.ME.MS.MA.MZ.MM.NA.NR.NP.NL.AN.NC.NZ.NI.NE.NG.NU.NF.MK.NO.OM.PK.PS.PA.PG.PY.PE.PH.PN.PL.PT.QA.CM.RE.RO.RU.RW.BL.SH.KN.LC.MF.PM.WS.SM.ST.SA.SN.RS.SC.SL.SG.SX.SK.SI.SB.SO.ZA.GS.KR.SS.ES.LK.VC.SD.SR.SJ.SE.CH.SY.TW.TJ.TZ.TH.TL.TG.TK.TO.TT.TA.TN.TR.TM.TC.TV.UG.UA.AE.GB.US.UM.UY.UZ.VU.VE.VN.VG.WF.EH.YE.ZM.ZW.ZZ".split("."), Ue = (e) => {
	if (!e?.trim()) return "Please add a valid subdomain";
	let t = ["https://", "http://"].find((t) => e.startsWith(t)), n = t ? `Please remove the protocol \`${t}\` from the hostname` : "", r = e.endsWith("/") ? "Please remove the trailing `/` from the hostname" : "";
	if (!t && e.includes("@")) return "Please remove the `@` from the hostname";
	if (/\s/.test(e)) return "Please remove the spaces from the hostname";
	if (n && r) return `Please remove the protocol \`${t}\` and the trailing \`/\` from the hostname`;
	if (n) return n;
	if (r) return r;
};
//#endregion
//#region src/utils/jwt.ts
function We(e) {
	let t = e.split(".")[1];
	if (!t) throw Error("Invalid token");
	let n = t.replace(/-/g, "+").replace(/_/g, "/");
	try {
		return JSON.parse(atob(n).toString());
	} catch (e) {
		throw Error(`Failed to parse the JSON Web Token with the following error: ${e}`);
	}
}
//#endregion
//#region src/hooks/useInboundOAuthContext/useInboundOAuthContext.ts
var Y = w(null);
function Ge() {
	let e = D(Y);
	if (e === null) throw Error("useInboundOAuthContext requires InboundOAuthContext to be used higher up in the component tree, below InboundOAuthContext.Provider");
	return e;
}
//#endregion
//#region src/hooks/useInboundOAuthContext/useInboundOAuthContext.utils.test.ts
function Ke() {
	return {
		isInboundOAuth: !1,
		setIsInboundOAuth: () => {},
		pairingCode: void 0,
		setPairingCode: () => {},
		shopifyDomain: void 0,
		setShopifyDomain: () => {},
		hasTriggeredAuthorization: !1,
		setHasTriggeredAuthorization: () => {}
	};
}
//#endregion
//#region src/hooks/useWidgetContext/useWidgetContext.ts
var qe = w(null), Je = qe.Provider;
function Ye() {
	let e = D(qe);
	if (e === null) throw Error("useWidgetContext requires WidgetContext to be used higher up in the component tree, below WidgetContextProvider");
	return e;
}
//#endregion
//#region src/utils/testing.ts
function Xe() {
	window._partner = { events: { emit: () => {} } };
}
var Ze = {
	useMutation: r,
	useQuery: () => ({
		data: void 0,
		loading: !1,
		error: void 0
	}),
	useLazyQuery: () => [() => {}, { loading: !1 }],
	executeQuery: () => {},
	showNotification: () => {},
	showModal: () => {}
}, Qe = { baseUrl: "http://localhost/graphql" };
function $e(e, { mocks: t = [], overrides: n = {}, inboundOAuthContext: r = {} } = {}) {
	let i = vi.fn(), a = vi.fn(), o = {
		configuration: Qe,
		handleRedirect: i,
		showNotification: a,
		featureFlags: {
			shopifySalesAttribution: !1,
			sidebarConditions: !1
		},
		...n
	};
	return {
		...L(T(ae, { mocks: t }, T(Y.Provider, { value: {
			...Ke(),
			...r
		} }, T(Je, { value: Ze }, T(e, o))))),
		handleRedirect: i,
		showNotification: a
	};
}
function et({ id: e, configuration: t }) {
	let n = t?.settings ?? [];
	return {
		request: {
			query: z,
			variables: { id: e }
		},
		result: { data: { Management: { widgetConfigurations: [{
			id: e,
			type: t?.type ?? "UNKNOWN",
			name: t?.name ?? "Test widget",
			enabled: t?.enabled ?? !0,
			misconfigured: t?.misconfigured ?? !1,
			misconfigurationCause: t?.misconfigurationCause ?? null,
			additionalProperties: t?.additionalProperties ?? null,
			settings: n
		}] } } }
	};
}
function tt({ variables: e, result: t }) {
	return {
		request: {
			query: V,
			variables: e
		},
		result: { data: { Management: { createWidgetConfiguration: {
			id: t?.id ?? "new-id",
			name: t?.name ?? e.name,
			enabled: t?.enabled ?? e.enabled,
			misconfigured: t?.misconfigured ?? !1,
			misconfigurationCause: t?.misconfigurationCause ?? null,
			additionalProperties: t?.additionalProperties ?? null,
			settings: t?.settings ?? []
		} } } }
	};
}
function nt({ variables: e, result: t }) {
	return {
		request: {
			query: B,
			variables: e
		},
		result: { data: { Management: { updateWidgetConfiguration: {
			id: e.id,
			name: t?.name ?? e.name,
			enabled: t?.enabled ?? e.enabled ?? !0,
			misconfigured: t?.misconfigured ?? !1,
			misconfigurationCause: t?.misconfigurationCause ?? null,
			additionalProperties: t?.additionalProperties ?? null,
			settings: t?.settings ?? []
		} } } }
	};
}
function rt({ id: e }) {
	return {
		request: {
			query: H,
			variables: { id: e }
		},
		result: { data: { Management: { deleteWidgetConfiguration: { id: e } } } }
	};
}
//#endregion
//#region src/utils/widgetSettingsConversion/widgetSettingsConversion.ts
function it(e, t) {
	let n = {};
	for (let r of t) {
		let t = e.find((e) => e.key === r.key)?.value;
		r.secret && t === void 0 || (r.type === "boolean" ? n[r.key] = ze(t, r.defaultValue) : n[r.key] = Be(t, r.defaultValue));
	}
	return n;
}
function at(e, t) {
	return t.filter((t) => e[t.key] !== void 0).map((t) => ({
		key: t.key,
		value: String(e[t.key]),
		secret: t.secret
	}));
}
//#endregion
//#region src/utils/widgetSettingsConversion/widgetSettingsConversion.utils.ts
function ot(e) {
	return Object.fromEntries(e.map((e) => [e.key, e.label]));
}
async function st(e, { fieldDefinitions: t, isCreationMode: n, create: r, update: i }) {
	let a = at(e, t), o = {
		name: e.name,
		enabled: e.enabled,
		settings: a
	};
	n ? await r(o) : await i(o);
}
//#endregion
//#region src/helpers/dev-helper.ts
function ct(e) {
	let { user_id: t, iss: n } = We(e);
	return {
		"x-integration-user-id": t,
		"x-integration-organization-id": n
	};
}
function lt(e) {
	return e.startsWith("http://localhost");
}
//#endregion
//#region src/hooks/useInboundOAuthContext/inboundOAuthContextProvider.tsx
var ut = ({ children: e }) => {
	let [t, n] = A(!1), [r, i] = A(), [a, o] = A(), [s, c] = A(!1), l = k(() => ({
		isInboundOAuth: t,
		setIsInboundOAuth: n,
		pairingCode: r,
		setPairingCode: i,
		shopifyDomain: a,
		setShopifyDomain: o,
		hasTriggeredAuthorization: s,
		setHasTriggeredAuthorization: c
	}), [
		t,
		r,
		a,
		s
	]);
	return /* @__PURE__ */ M(Y.Provider, {
		value: l,
		children: e
	});
};
//#endregion
//#region src/hooks/useTracking/useTracking.ts
function X() {
	return { track: (e, t) => window._partner.events.emit(e, t) };
}
//#endregion
//#region src/components/oAuth/oAuthSettings.tsx
var dt = (e) => {
	switch (e) {
		case "CONNECTED": return {
			icon: "check-circle-filled",
			color: C.green[500],
			tooltip: "Connected"
		};
		case "CONNECTING": return {
			icon: "sync",
			color: C.neutral[500],
			tooltip: "Connecting.."
		};
		case "CONNECTION_FAILED": return {
			icon: "close-circle-filled",
			color: C.red[500],
			tooltip: "Connection failed"
		};
		case "CONNECTION_TIMEOUT": return {
			icon: "exclamation-triangle-filled",
			color: C.red[200],
			tooltip: "Connection timeout"
		};
		default: return {
			icon: "exclamation-circle-filled",
			color: C.neutral[500],
			tooltip: "Not connected"
		};
	}
}, ft = ({ configuration: e, integrationId: t, integrationType: n, label: r }) => {
	let [i, a] = A("CONNECTING"), [o, s] = A(""), [l, m] = A(null), { track: h } = X(), { icon: g, color: _, tooltip: v } = dt(i), [b, C] = A(0), [w, T] = A(2e3), [E, D] = A(3), { isInboundOAuth: O, pairingCode: k, setPairingCode: ee, setIsInboundOAuth: P, setShopifyDomain: te, hasTriggeredAuthorization: F, setHasTriggeredAuthorization: I } = Ge(), [ae, L] = A(!(O && !F && k)), { baseUrl: R } = e, oe = `${R}/auth/connect/${n.toLowerCase()}/${t}`, z = `${R}/auth/status/${n.toLowerCase()}/${t}`, B = `${R}/integrations/pairing/approve`, V = i === "CONNECTING", H = () => {
		L(!1), C(0);
	}, se = async () => {
		D(15);
		try {
			let { data: e } = await (await fetch(z, { ...Z(R)?.requestInit })).json(), { status: r, createdAt: i, createdByName: o } = e;
			switch (r) {
				case "CONNECTING":
					a("CONNECTING");
					break;
				case "CONNECTED":
					if (h("settings:view:oauth:succeeded", {
						widgetId: t,
						widgetType: n
					}), a("CONNECTED"), i && o) {
						let e = new Date(i);
						isNaN(e.getTime()) || m(e), s(o);
					}
					H();
					break;
				case "NOT_CONNECTED":
				case "CONNECTION_FAILED":
					a(r), H();
					break;
			}
		} catch (e) {
			console.warn(`Fetching OAuth status failed for ${n} ${t}`, e), a("CONNECTION_FAILED");
		}
	};
	ne(() => {
		b >= E ? (a("CONNECTION_TIMEOUT"), H()) : (se(), C(b + 1));
	}, ae ? w : null);
	let U = async () => {
		h("settings:view:oauth:started", {
			widgetId: t,
			widgetType: n
		});
		try {
			let { data: e } = await (await fetch(oe, { ...Z(R)?.requestInit })).json(), { url: t } = e, n = window.innerWidth / 2 - 620 / 2, r = window.innerHeight / 2 - 800 / 2;
			a("CONNECTING"), L(!0), window.open(t, "DixaPartnerOAuth", `toolbar=no,
						location=no,
						status=no,
						menubar=no,
						scrollbars=yes,
						resizable=yes,
						width=620,
						height=800,
						left=${n},
						top=${r}`);
		} catch (e) {
			console.warn(`Fetching OAuth connection failed for ${n} ${t}`, e), a("CONNECTION_FAILED");
		}
	}, ce = async (e) => {
		h("settings:view:oauth:started", {
			widgetId: t,
			widgetType: n
		});
		try {
			let n = Z(R), r = n?.requestInit.headers ?? {}, i = n?.authData.access_token, o = await fetch(B, {
				...n?.requestInit,
				method: "POST",
				headers: {
					...r,
					authorization: `Basic ${i ? btoa(`token:${i}`) : ""}`
				},
				body: JSON.stringify({
					pairingCode: e,
					integrationId: t
				})
			});
			o.ok || (await o.json().catch(() => void 0))?.data?.error === "PAIRING_NOT_PENDING" ? L(!0) : (a("CONNECTION_FAILED"), L(!1));
		} catch (e) {
			console.warn(`Approving pairing failed for ${n} ${t}`, e), a("CONNECTION_FAILED");
		}
	};
	return re(() => {
		O && !F && (I(!0), P(!1), k ? ce(k) : U());
	}), ie(() => {
		P(!1), ee(void 0), te(void 0), I(!1);
	}), /* @__PURE__ */ N(j, { children: [/* @__PURE__ */ M(f, {
		span: 3,
		children: /* @__PURE__ */ M(u, {
			label: r,
			meta: { warning: "All agents interact with the widget using your access permissions." },
			style: { marginBottom: 20 },
			children: /* @__PURE__ */ N(d, {
				flexDirection: "row",
				alignItems: "baseline",
				gap: "300",
				children: [/* @__PURE__ */ M(c, {
					icon: "key",
					variant: "secondary",
					onClick: U,
					disabled: V,
					style: { marginBottom: 8 },
					children: "Start authorization"
				}), /* @__PURE__ */ M(S, {
					content: v,
					children: V ? /* @__PURE__ */ M(y, {
						"data-testid": "oauth-button-spinner",
						size: 18
					}) : /* @__PURE__ */ N(d, {
						alignItems: "center",
						gap: "200",
						children: [/* @__PURE__ */ M(p, {
							"data-testid": "oauth-button-status-icon",
							name: g,
							color: _
						}), i === "CONNECTED" && o && l && /* @__PURE__ */ N(x.Paragraph, {
							variant: "4",
							subdued: !0,
							children: [
								"Authorized by ",
								o,
								" at",
								" ",
								Me(l).format("DD MMM YYYY @ HH:mm")
							]
						})]
					})
				})]
			})
		})
	}), /* @__PURE__ */ M(f, { span: 3 })] });
};
function pt() {
	let e = localStorage.getItem("authData");
	return e ? JSON.parse(e) : null;
}
function Z(e) {
	let t = pt(), n = t?.access_token;
	if (!(!t || !n)) return {
		requestInit: {
			method: "GET",
			headers: {
				"content-type": "application/json",
				authorization: `Bearer ${n}`,
				...lt(e) && ct(n)
			}
		},
		authData: t
	};
}
//#endregion
//#region src/components/displayAttributeValue/displayAttributeValue.utils.tsx
var mt = ({ value: e }) => /* @__PURE__ */ M(p, {
	name: e ? "check-circle-filled" : "close-circle-filled",
	color: e ? C.green[500] : C.red[500],
	size: 14,
	"data-testid": `displayAttributeValue-icon-${e ? "true" : "false"}`
}), ht = ({ value: e }) => /* @__PURE__ */ M(x.Paragraph, {
	variant: "5",
	color: "secondary",
	align: "right",
	children: e.join(", ")
}), gt = ({ value: e }) => /* @__PURE__ */ M(o, {
	variant: "success",
	size: "small",
	children: e
}), _t = ({ value: e }) => {
	let t = e.replace("days_ago: ", ""), n = t.startsWith("-"), r = t === "0", i = n ? `${t.replace("-", "")} days ago` : `in ${t} days`;
	return /* @__PURE__ */ M(x.Paragraph, {
		variant: "5",
		color: "secondary",
		children: r ? "today" : i
	});
}, vt = ({ value: e }) => /* @__PURE__ */ M(x.Paragraph, {
	variant: "5",
	color: "secondary",
	children: e.format(Re)
}), Q = ({ value: e }) => /* @__PURE__ */ M(o, {
	variant: "info",
	size: "small",
	children: e
}), yt = (e, t) => {
	if (e == null) return null;
	if (t === "string") return /* @__PURE__ */ M(Q, { value: e.toString() });
	if (Array.isArray(e)) return /* @__PURE__ */ M(ht, { value: e });
	if (typeof e == "boolean" || e === "true" || e === "false") return /* @__PURE__ */ M(mt, { value: e === "true" || e === !0 });
	if (typeof e == "number" || /^\d*\.?\d+$/.test(e)) return /* @__PURE__ */ M(gt, { value: e });
	if (e.startsWith("days_ago: ")) return /* @__PURE__ */ M(_t, { value: e });
	let n = Me(e);
	return n.isValid() ? /* @__PURE__ */ M(vt, { value: n }) : /* @__PURE__ */ M(Q, { value: e });
}, bt = (e) => {
	let { isCreationMode: t = !1, label: n, helpIcon: r, name: i } = e, [a, o] = A(t);
	if (!a) {
		let e = typeof n == "string" ? n : "";
		return /* @__PURE__ */ M(u, {
			label: n,
			helpIcon: r,
			children: /* @__PURE__ */ N(c, {
				"data-testid": `secret-field-button-${i}`,
				variant: "secondary",
				icon: "pen",
				onClick: () => o(!0),
				children: ["Update ", e]
			})
		});
	}
	return /* @__PURE__ */ M(xt, {
		...e,
		isCreationMode: t,
		onClose: () => o(!1)
	});
}, xt = (e) => {
	let { isCreationMode: t, componentProps: n, onClose: r } = e, i = {
		...n,
		prefix: t ? n?.prefix : {
			type: "button",
			button: {
				icon: "close",
				onClick: r
			}
		}
	};
	return /* @__PURE__ */ M(R, {
		...e,
		componentProps: i,
		shouldUnregister: !0
	});
}, $ = {
	wrapper: "_wrapper_1lmim_1",
	wrapperBox: "_wrapperBox_1lmim_4",
	wrapperBoxErrorBorder: "_wrapperBoxErrorBorder_1lmim_9"
}, St = (e, t) => e !== "" && t !== "" ? window.btoa(`${e}:${t}`) : "", Ct = (e) => {
	let { isCreationMode: t = !1, label: n, name: r } = e, [i, a] = A(t);
	if (!i) {
		let e = typeof n == "string" ? n : "";
		return /* @__PURE__ */ M(u, {
			label: n,
			children: /* @__PURE__ */ N(c, {
				"data-testid": `secret-field-button-${r}`,
				variant: "secondary",
				icon: "pen",
				onClick: () => a(!0),
				children: ["Update ", e]
			})
		});
	}
	return /* @__PURE__ */ M(wt, {
		...e,
		isCreationMode: t,
		onClose: () => a(!1)
	});
}, wt = (e) => {
	let { name: t, control: n, label: r, rules: i, isCreationMode: a, usernameLabel: o, passwordLabel: s, usernamePlaceholder: c, passwordPlaceholder: f, onClose: p } = e, { field: m, fieldState: h } = P({
		name: t,
		control: n,
		rules: i,
		shouldUnregister: !0
	}), [g, _] = A(""), [v, y] = A(""), b = (e) => {
		_(e), m.onChange(St(e, v));
	}, x = (e) => {
		y(e), m.onChange(St(g, e));
	}, S = !!i?.required;
	return /* @__PURE__ */ M(u, {
		label: r,
		required: S,
		meta: {
			touched: h.isTouched,
			error: h.error?.message
		},
		className: $.wrapper,
		children: /* @__PURE__ */ N(d, {
			gap: "300",
			flexDirection: "column",
			className: oe($.wrapperBox, { [$.wrapperBoxErrorBorder]: !!h.error }),
			children: [/* @__PURE__ */ M(l, {
				noAlert: !0,
				required: S,
				label: o,
				placeholder: c,
				input: {
					name: t,
					value: g,
					onChange: (e) => b(e?.target.value ?? ""),
					onBlur: m.onBlur
				},
				...!a && { prefix: {
					type: "button",
					button: {
						icon: "close",
						onClick: p
					}
				} }
			}), /* @__PURE__ */ M(l, {
				noAlert: !0,
				required: S,
				label: s,
				placeholder: f,
				input: {
					name: t,
					value: v,
					onChange: (e) => x(e?.target.value ?? ""),
					onBlur: m.onBlur
				},
				...!a && { prefix: {
					type: "button",
					button: {
						icon: "close",
						onClick: p
					}
				} }
			})]
		})
	});
}, Tt = {
	submit: "Submit",
	delete: "Delete",
	confirmDelete: "Yes",
	cancelDelete: "No"
}, Et = ({ integrationType: e, integrationId: t, widgetName: n, isCreationMode: r, isSubmitting: i, automationCouplingState: a, onConfirmDelete: o, labels: s, deleteConfirmationBody: l, confirmDeleteVariant: u = "primary" }) => {
	let { track: f } = X(), [p, m] = A(!1), h = {
		...Tt,
		...s
	}, g = !a || !a.isCoupled;
	return /* @__PURE__ */ N(j, { children: [/* @__PURE__ */ N(d, {
		margin: "300 0 0 0",
		children: [/* @__PURE__ */ M(c, {
			type: "submit",
			isLoading: i,
			disabled: i,
			children: h.submit
		}), !r && /* @__PURE__ */ M(S, {
			content: "The widget is used in automations",
			disabled: g,
			children: /* @__PURE__ */ M(c, {
				style: { marginLeft: 20 },
				icon: "trash",
				variant: "secondary",
				type: "button",
				onClick: () => {
					t && f("settings:view:delete:requested", {
						widgetId: t,
						widgetType: e
					}), m(!0);
				},
				disabled: !g,
				isLoading: a?.isLoading,
				children: h.delete
			})
		})]
	}), /* @__PURE__ */ M(Oe, {
		isOpen: p,
		setIsOpen: m,
		confirmVariant: u,
		confirmLabel: h.confirmDelete,
		cancelLabel: h.cancelDelete,
		onCancel: () => {
			t && f("settings:view:delete:canceled", {
				widgetId: t,
				widgetType: e
			});
		},
		onConfirm: o,
		children: /* @__PURE__ */ M(d, { children: l ?? /* @__PURE__ */ N(j, { children: [
			"Are you sure you want to delete the ",
			e,
			" integration \"",
			n,
			"\"?"
		] }) })
	})] });
}, Dt = { shopifySalesAttribution: "partner-integrations-shopify-sales-attribution" }, Ot = e`
  query read($conversationId: String!) {
    Storage {
      widgetData(conversation: $conversationId)
    }
  }
`, kt = e`
  mutation store($conversationId: String!, $data: Storage_JSONObject) {
    Storage {
      storeWidgetData(conversation: $conversationId, data: $data) {
        data
      }
    }
  }
`;
function At(e) {
	let { useQuery: t, useMutation: n } = Ye(), [r, i] = A(), [a, o] = A(), [s, c] = A(!1), { loading: l, data: u, error: d } = t(Ot, {
		skip: !e,
		variables: { conversationId: e?.toString() }
	}), [f, { loading: p, error: m }] = n(kt);
	return O(() => {
		!l && u && i(u?.Storage?.widgetData ?? {});
	}, [u, l]), O(() => d && o(d), [d]), O(() => c(l), [l]), O(() => m && o(m), [m]), O(() => c(p), [p]), {
		data: r,
		loading: s,
		store: async (t, n) => await f({ variables: {
			conversationId: (n ?? e)?.toString(),
			data: t
		} }).then(({ data: e }) => i(e?.Storage?.storeWidgetData?.data ?? {})),
		error: a
	};
}
//#endregion
//#region src/hooks/useWidgetSettingsMutations/useWidgetSettingsMutations.ts
var jt = ({ integrationId: e, integrationType: t, handleRedirect: n, showNotification: i }) => {
	let { track: a } = X(), [o, s] = A(!1), [c, l] = A(), [u, d] = A(null), f = E((e) => (t) => {
		l(t), s(!1), i({
			title: "Something went wrong",
			text: `The ${e} of the widget was not successful.`,
			icon: "exclamation-triangle-filled",
			severity: "warning"
		});
	}, [i]), [p] = r(V, { onError: f("creation") }), [m] = r(B, { onError: f("update") }), [h] = r(H, { onError: f("deletion") });
	return {
		create: E(async ({ name: e, enabled: r, settings: o }) => {
			a("settings:create:submitted", { widgetType: t }), s(!0), l(void 0);
			let { data: c } = await p({ variables: {
				type: t,
				name: e,
				enabled: r,
				settings: o
			} });
			s(!1);
			let u = c?.Management?.createWidgetConfiguration;
			if (!u) {
				i({
					title: "Something went wrong",
					text: "The creation of the widget was not successful.",
					icon: "exclamation-triangle-filled",
					severity: "warning"
				});
				return;
			}
			i({
				title: "Creating was successful",
				text: "Creating the widget was successful.",
				icon: "check-circle-filled",
				severity: "success"
			}), n(u.id);
		}, [
			p,
			n,
			t,
			i,
			a
		]),
		update: E(async ({ name: n, enabled: r, settings: o }) => {
			if (!e) return;
			a("settings:view:change:submitted", {
				widgetId: e,
				widgetType: t
			}), s(!0), l(void 0);
			let { data: c } = await m({ variables: {
				id: e,
				name: n,
				enabled: r,
				settings: o
			} });
			s(!1);
			let u = c?.Management?.updateWidgetConfiguration;
			if (!u) {
				i({
					title: "Something went wrong",
					text: "The update of the widget was not successful.",
					icon: "exclamation-triangle-filled",
					severity: "warning"
				});
				return;
			}
			u.misconfigured ? d(u.misconfigurationCause ?? "The configuration of the integration is not correct. Please check the settings.") : d(null), i({
				title: "Updating was successful",
				text: "Updating the widget was successful.",
				icon: "check-circle-filled",
				severity: "success"
			});
		}, [
			e,
			t,
			i,
			a,
			m
		]),
		remove: E(async () => {
			if (!e) return;
			a("settings:view:delete:confirmed", {
				widgetId: e,
				widgetType: t
			}), s(!0), l(void 0);
			let { data: r } = await h({ variables: { id: e } });
			s(!1), r?.Management?.deleteWidgetConfiguration && (n(), i({
				title: "Deletion was successful",
				text: "The deletion of the widget was successful.",
				icon: "check-circle-filled",
				severity: "success"
			}));
		}, [
			h,
			n,
			e,
			t,
			i,
			a
		]),
		isLoading: o,
		error: c,
		misconfigurationCause: u,
		setMisconfigurationCause: d
	};
};
//#endregion
//#region src/hooks/useWidgetSettingsQuery/useWidgetSettingsQuery.ts
function Mt({ integrationId: e, fieldDefinitions: t, form: n, onMisconfigured: r }) {
	let [a, o] = A(!1), [s, c] = A(), { loading: l, error: u, refetch: d } = i(z, {
		variables: { id: e },
		skip: !e,
		onCompleted: (e) => {
			let i = e?.Management?.widgetConfigurations?.[0];
			if (!i) {
				o(!0), c(void 0);
				return;
			}
			o(!1), c(i), n.reset({
				...it(i.settings ?? [], t),
				enabled: !!i.enabled,
				name: i.name
			}), i.misconfigured && r?.(i.misconfigurationCause ?? "The configuration of the integration is not correct. Please check the settings.");
		}
	});
	return O(() => {
		o(!1), c(void 0);
	}, [e]), {
		isLoading: l,
		error: u,
		isWidgetUnknown: a,
		refetch: d,
		widgetConfiguration: s
	};
}
//#endregion
export { mt as DisplayAttributeBoolean, vt as DisplayAttributeDate, _t as DisplayAttributeDaysAgo, gt as DisplayAttributeNumber, Q as DisplayAttributeString, ht as DisplayAttributeStringArray, De as DisplayErrors, Y as InboundOAuthContext, ut as InboundOAuthContextProvider, Oe as IntegrationModal, Ae as MisconfigurationBanner, ft as OAuthSettings, Ct as PartnerHookFormBasicAuth, bt as PartnerHookFormSecretText, je as PartnerSettingsWrapper, Je as WidgetContextProvider, Et as WidgetSettingsFormFooter, Ie as capitalizeFirstCharacter, He as countryCodes, Ke as createMockInboundOAuthContextOptions, tt as createWidgetConfigurationCreateMock, rt as createWidgetConfigurationDeleteMock, V as createWidgetConfigurationMutation, et as createWidgetConfigurationQueryMock, nt as createWidgetConfigurationUpdateMock, Fe as deepClone, Re as defaultDateFormat, ke as defaultMisconfigurationCause, Qe as defaultPartnerSettingsConfiguration, Ze as defaultWidgetContextValue, H as deleteWidgetConfigurationMutation, yt as displayAttributeValue, at as formValuesToSettings, dt as getConnectionStatusValues, Ve as getCountryNameFromCountryCode, ct as getPartnerDevApiHeaders, z as getWidgetConfigurationByIdQuery, st as handleWidgetSubmit, ue as hasDixaHeaderCheckError, de as hasDownstreamApiAuthorizationError, be as hasDownstreamApiBadRequestError, ve as hasDownstreamApiConflictError, xe as hasDownstreamApiForbiddenError, ge as hasDownstreamApiNotFoundError, fe as hasDownstreamApiPermissionError, me as hasDownstreamApiServiceUnavailableError, Ce as hasDownstreamApiTooManyRequestsError, Te as hasWidgetMisconfiguredError, Le as humanizeKey, W as isDixaHeaderCheckError, G as isDownstreamApiAuthorizationError, ye as isDownstreamApiBadRequestError, _e as isDownstreamApiConflictError, q as isDownstreamApiForbiddenError, he as isDownstreamApiNotFoundError, K as isDownstreamApiPermissionError, pe as isDownstreamApiServiceUnavailableError, Se as isDownstreamApiTooManyRequestsError, lt as isRunningLocalPartnerApi, we as isWidgetMisconfiguredError, ce as makeExecuteQuery, U as makeUseLazyQuery, le as makeUseMutation, se as makeUseQuery, ot as mapLabels, We as parseAccessToken, ze as parseBoolean, Be as parseString, Dt as partnerFeatureNameToFlagMapping, $e as renderPartnerSettings, it as settingsToFormValues, Xe as stubPartnerEventsBusForTests, B as updateWidgetConfigurationMutation, Ee as useCopyWithDelay, At as useData, Ge as useInboundOAuthContext, X as useTracking, Ye as useWidgetContext, jt as useWidgetSettingsMutations, Mt as useWidgetSettingsQuery, Ue as validateApiHostName };
